import BaseCarousel from './components/BaseCarousel';
import CarouselWithPreview from './components/CarouselWithPreview';

const Carousel = BaseCarousel;
Carousel.WithPreview = CarouselWithPreview;

export default Carousel;
